// All facts verified 2026-09-28 against nordicprolo.se and BokaDirekt. See /app/memory/SOURCES.md
export const VERIFIED_AT = "2026-09-28";
export const VERIFIED_LABEL = "28 september 2026";

export const BOKADIREKT_PROFILE = "https://www.bokadirekt.se/places/nordic-prolo-smartklinik-59314";

export const site = {
  name: "Nordic Prolo Smärtklinik",
  shortName: "Nordic Prolo",
  tagline: "Läkarledd smärtbehandling",
  logo: "/assets/logo.webp",
  phone: { display: "08-99 35 23", href: "tel:+468993523" },
  email: { display: "info@nordicprolo.se", href: "mailto:info@nordicprolo.se" },
  instagram: { display: "@nordicprolo", href: "https://www.instagram.com/nordicprolo" },
  noReferral: "Ingen remiss krävs",
};

// Editable trust value. Update value, count and verifiedAt together.
export const rating = {
  source: "BokaDirekt",
  value: "4,8",
  numeric: 4.8,
  scale: 5,
  count: 112,
  verifiedAt: VERIFIED_AT,
  verifiedLabel: VERIFIED_LABEL,
  url: `${BOKADIREKT_PROFILE}#reviews`,
};

export const booking = {
  profileUrl: BOKADIREKT_PROFILE,
  title: "Var vill du boka?",
  intro: "Välj mottagning. Bokningen görs hos BokaDirekt, där du ser lediga tider.",
  allServicesLabel: "Återbesök eller annan tjänst? Se alla tjänster på BokaDirekt",
};

export const clinics = [
  {
    id: "nacka",
    city: "Nacka",
    title: "Nacka Forum",
    addressLines: ["Nacka Forum, Signum / HLTH", "Forumvägen 14, plan 11", "131 53 Nacka"],
    postal: { street: "Forumvägen 14", zip: "131 53", locality: "Nacka" },
    notes: [
      "Nacka Forum ligger cirka 5 kilometer sydost om Stockholm City.",
      "Mottagningen finns i Signum-huset inne i Nacka Forum – följ skyltningen i taket.",
      "Parkering finns i Nacka Forum.",
    ],
    mapsUrl: "https://www.google.com/maps/search/?api=1&query=Forumv%C3%A4gen+14,+131+53+Nacka",
    bookingUrl:
      "https://www.bokadirekt.se/boka-tjanst/nordic-prolo-smartklinik-59314/nybesok-konsultation-hos-lakare-3126894",
    bookingLabel: "Nybesök/Konsultation hos läkare",
    services: [
      { name: "Nybesök/Konsultation hos läkare", price: "1 500 kr", note: "cirka 60 min" },
      { name: "Distanskonsultation (video/telefon)", price: "1 500 kr" },
      { name: "Nybesök + smärtbehandling, samma tillfälle", price: "6 500 kr" },
      { name: "Smärtbehandling hos läkare (återbesök)", price: "5 500 kr", note: "cirka 45–60 min" },
      { name: "Behandling mot nervsmärta hos läkare", price: "5 500 kr", note: "cirka 45–60 min" },
      { name: "PRP-behandling", price: "8 500 kr" },
      { name: "MLS-laser – engångsbehandling", price: "1 100 kr" },
      { name: "MLS-laser – behandlingspaket (12 tillfällen)", price: "13 000 kr" },
      { name: "Neuropatiutredning med B12-bedömning och behandlingsplan", price: "7 500 kr" },
      { name: "SUDOSCAN (endast undersökning)", price: "2 000 kr" },
      { name: "Receptförnyelse vitamin B12 inkl. blodprover", price: "1 000 kr" },
      { name: "Blodprov intrinsic factor & parietalcellsantikroppar", price: "3 500 kr" },
    ],
  },
  {
    id: "goteborg",
    city: "Göteborg",
    title: "Göteborg",
    addressLines: ["Södra Larmgatan 4", "Göteborg"],
    postal: { street: "Södra Larmgatan 4", zip: null, locality: "Göteborg" },
    notes: [
      "Läkaren är på plats i Göteborg en gång per månad.",
      "Aktuella dagar syns som lediga tider i BokaDirekt.",
      "Kontrollera adressen i din bokningsbekräftelse.",
    ],
    mapsUrl: "https://www.google.com/maps/search/?api=1&query=S%C3%B6dra+Larmgatan+4,+G%C3%B6teborg",
    bookingUrl:
      "https://www.bokadirekt.se/boka-tjanst/nordic-prolo-smartklinik-59314/nybesok-konsultation-hos-lakare-goteborg-3312673",
    bookingLabel: "Nybesök/Konsultation hos läkare (Göteborg)",
    services: [
      { name: "Nybesök/Konsultation hos läkare", price: "1 500 kr", note: "cirka 60 min" },
      { name: "Nybesök + smärtbehandling, samma tillfälle", price: "6 500 kr" },
      { name: "Smärtbehandling hos läkare (återbesök)", price: "5 500 kr", note: "cirka 45–60 min" },
      { name: "Behandling mot nervsmärta hos läkare", price: "5 500 kr" },
      { name: "Neuropatiutredning med B12-bedömning och behandlingsplan", price: "7 500 kr" },
    ],
  },
];

export const nav = [
  { to: "/besvar", label: "Besvär" },
  { to: "/behandlingar", label: "Behandlingar" },
  { to: "/om-nordic-prolo", label: "Om Nordic Prolo" },
  { to: "/kliniker-boka", label: "Kliniker & boka" },
];

export const memberships = [
  { name: "Sveriges Läkarförbund", url: "https://slf.se/" },
  { name: "Svenska Smärtläkarföreningen", url: "https://slf.se/svenska-smartlakarforeningen/" },
  { name: "Swedish Pain Society", url: "https://www.swedishpainsociety.com/" },
];

export const doctor = {
  name: "Dr Hivar Kaftan",
  title: "Legitimerad läkare med inriktning smärtbehandling",
  photo: "/assets/dr-hivar.jpg",
  secondaryPhoto: "/assets/dr-hivar-2.webp",
  photoAlt: "Porträtt av Dr Hivar Kaftan, legitimerad läkare på Nordic Prolo",
  facts: [
    "Legitimerad läkare med inriktning smärtbehandling",
    "Flera års arbete med fokus på långvarig smärta",
    "Avancerad utbildning genom American Association of Orthopedic Medicine (AAOM)",
    "Utför proloterapi, nervproloterapi, PRP och MLS-laser",
  ],
  bio: [
    "På Nordic Prolo träffar du Dr Hivar Kaftan, legitimerad läkare med inriktning smärtbehandling. Under flera år har han fokuserat på att behandla långvarig smärta.",
    "Många patienter som söker sig hit har redan provat flera vägar inom vården. Därför börjar varje behandling med en grundlig genomgång av besvären, tidigare behandlingar och dina mål – och en individuell plan som tar hänsyn till både fysiska och psykiska aspekter av smärta.",
  ],
  training:
    "Hivar har genomgått avancerad utbildning genom American Association of Orthopedic Medicine (AAOM), en internationell organisation inom regenerativ ortopedisk medicin.",
  volunteer:
    "Vid sidan av kliniken arbetar han som volontär och reser regelbundet på uppdrag för att utföra proloterapibehandlingar för människor i låginkomstländer.",
};

export const meta = {
  home: {
    title: "Nordic Prolo Smärtklinik – läkarledd smärtbehandling i Nacka och Göteborg",
    description:
      "Proloterapi, nervproloterapi, PRP och MLS-laser hos legitimerad läkare Dr Hivar Kaftan. Mottagningar i Nacka Forum och Göteborg. Ingen remiss krävs.",
  },
  besvar: {
    title: "Var har du ont? Besvär vi arbetar med | Nordic Prolo",
    description:
      "Utgå från var du har ont – nacke, axel, rygg, höft, knä, fot med flera. Se vilka besvär Nordic Prolo arbetar med och vilka behandlingar som kan vara aktuella.",
  },
  behandlingar: {
    title: "Behandlingar – proloterapi, nervproloterapi, PRP och MLS-laser | Nordic Prolo",
    description:
      "Så fungerar proloterapi, nervproloterapi, PRP, MLS-laser och neuropatiutredning hos Nordic Prolo – och hur ett besök går till.",
  },
  om: {
    title: "Om Nordic Prolo och Dr Hivar Kaftan | Nordic Prolo",
    description:
      "Möt Dr Hivar Kaftan, legitimerad läkare med inriktning smärtbehandling och utbildning genom AAOM. Läs om hur vi arbetar på Nordic Prolo Smärtklinik.",
  },
  kliniker: {
    title: "Kliniker och bokning – Nacka och Göteborg | Nordic Prolo",
    description:
      "Boka tid hos Nordic Prolo i Nacka Forum eller Göteborg via BokaDirekt. Adresser, tjänster, priser och kontaktformulär.",
  },
  notFound: {
    title: "Sidan hittades inte | Nordic Prolo",
    description: "Sidan du söker finns inte. Gå vidare till startsidan eller boka tid.",
  },
};
